var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskGauge3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 70,
    viewBox: "0 0 138 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_38619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383209 64.0531 1.54437 57.4861C3.99124 43.6478 10.628 30.782 20.7004 20.7096C33.6404 7.76962 51.1908 0.500002 69.4907 0.5C87.7906 0.499998 105.341 7.76962 118.281 20.7096C128.353 30.782 134.99 43.6478 137.437 57.4861C138.598 64.0531 133.085 69.5 126.416 69.5C119.747 69.5 114.499 63.9986 112.725 57.57C110.679 50.1544 106.74 43.3214 101.204 37.7863C92.7934 29.3753 81.3857 24.65 69.4907 24.65C57.5958 24.65 46.188 29.3753 37.777 37.7863C32.2418 43.3214 28.3029 50.1544 26.2564 57.57C24.4823 63.9986 19.2346 69.5 12.5657 69.5Z",
    fill: "#D5D6D8",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383483 64.0534 1.54461 57.4864C2.72925 50.7864 4.90228 44.2764 8.01128 38.1746C12.9547 28.4726 20.1242 20.0782 28.9335 13.6778C37.7429 7.27748 47.9419 3.0529 58.6968 1.3495C65.4606 0.278217 72.3235 0.223256 79.0616 1.167C85.666 2.09202 89.1423 9.01867 87.0815 15.3611C85.0207 21.7036 78.1671 24.9948 71.505 24.6953C68.4957 24.56 65.4702 24.7277 62.4746 25.2022C55.484 26.3094 48.8546 29.0554 43.1286 33.2156C37.4025 37.3758 32.7423 42.8322 29.5291 49.1385C28.1522 51.8409 27.0577 54.6664 26.2564 57.5702C24.4826 63.9988 19.2346 69.5 12.5657 69.5Z",
    fill: "#28245C",
    style: {
      fill: "#28245C",
      fill: "color(display-p3 0.1569 0.1412 0.3608)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383483 64.0534 1.54461 57.4864C2.72925 50.7864 4.90228 44.2764 8.01128 38.1746C12.9547 28.4726 20.1242 20.0782 28.9335 13.6778C37.7429 7.27748 47.9419 3.0529 58.6968 1.3495C65.4606 0.278217 72.3235 0.223256 79.0616 1.167C85.666 2.09202 89.1423 9.01867 87.0815 15.3611C85.0207 21.7036 78.1671 24.9948 71.505 24.6953C68.4957 24.56 65.4702 24.7277 62.4746 25.2022C55.484 26.3094 48.8546 29.0554 43.1286 33.2156C37.4025 37.3758 32.7423 42.8322 29.5291 49.1385C28.1522 51.8409 27.0577 54.6664 26.2564 57.5702C24.4826 63.9988 19.2346 69.5 12.5657 69.5Z",
    fill: "url(#grad3)",
    style: {},
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 12,
    r: 7,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad3",
    x1: "0%",
    y1: "50%",
    x2: "40%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEFADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCE359"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_38619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 69,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskGauge3);
export default __webpack_public_path__ + "static/media/risk-gauge-3.5938651bb982905b59bd03f01520f15e.svg";
export { ForwardRef as ReactComponent };